import React from 'react';
import { authUtilityURL } from '@consumer/auth-utility-loader';
export default () => [React.createElement("link", {
  rel: "modulepreload",
  href: authUtilityURL()
})];